import { ItemCardDetails } from "@/components/ItemCard";
import { type InstallationQuotationData } from "@repo/api";
import { Badge, LightMode, Variables } from "@repo/skapa";
import { t, useTranslation } from "@repo/translation";
import { FlexDiv, localizeDate, localizeDateAndTime } from "@repo/ui";
import { SimpleLabelField } from "@repo/ui";

interface InstallationQuotationCardDetailsProps {
  installationQuotation: InstallationQuotationData;
}

export const InstallationQuotationCardDetails = ({
  installationQuotation,
}: InstallationQuotationCardDetailsProps) => {
  const { dateFnsLocale } = useTranslation();
  const isRequestedStatus =
    installationQuotation.status?.toLowerCase() === "requested";
  const title = `${t("label.installation_quotation")}${!isRequestedStatus ? ` ${installationQuotation.quoteNumber}` : ""}`;
  const description = isRequestedStatus
    ? t("label.installation_quotation_await_salesforce_info")
    : `${t("label.date_sent")}: ${installationQuotation.docusignDateSent ? localizeDateAndTime(installationQuotation.docusignDateSent, dateFnsLocale) : "-"}`;

  return (
    <ItemCardDetails
      title={title}
      description={description}
      addOn={
        <div>
          <FlexDiv
            display="inline-flex"
            margin={`0 0 ${Variables.space25}`}
            gap={Variables.space50}
          >
            <Badge
              label={t(
                `installation_quotation_status.${installationQuotation.status?.toLowerCase()}`
              )}
              size="small"
            />
            {!isRequestedStatus && (
              <Badge
                label={
                  installationQuotation.depositPaid
                    ? t("label.deposit_paid")
                    : t("label.deposit_not_paid")
                }
                size="small"
                colour={installationQuotation.depositPaid ? "green" : "red"}
              />
            )}
          </FlexDiv>

          {!isRequestedStatus && (
            <SimpleLabelField
              small
              label={t("label.installation_start_date")}
              value={
                installationQuotation.installationStartDate
                  ? localizeDate(
                      installationQuotation.installationStartDate,
                      dateFnsLocale
                    )
                  : "-"
              }
              color={LightMode.colourTextAndIcon2}
            />
          )}
          {!isRequestedStatus && (
            <SimpleLabelField
              small
              label={t("label.installation_end_date")}
              value={
                installationQuotation.installationEndDate
                  ? localizeDate(
                      installationQuotation.installationEndDate,
                      dateFnsLocale
                    )
                  : "-"
              }
              color={LightMode.colourTextAndIcon2}
            />
          )}
        </div>
      }
    />
  );
};
